import { render, staticRenderFns } from "./LaptopForm.vue?vue&type=template&id=846f89fc&scoped=true&"
import script from "./LaptopForm.vue?vue&type=script&lang=js&"
export * from "./LaptopForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846f89fc",
  null
  
)

export default component.exports